import type { OpenAPI } from "simplydo/interfaces";

type UserLike = Pick<OpenAPI.Schemas["User"], "following"> | null | undefined;

export function getUserFollowing(user: UserLike, context: string) {
  const existingFollowing = user?.following || [];
  return existingFollowing.filter((f) => f.type === context);
}

export function userIsFollowingContext(
  user: UserLike,
  context: string,
  id: string,
) {
  const existingFollowingContext = getUserFollowing(user, context);
  const followingContent = existingFollowingContext.find((f) => f._id === id);
  return followingContent?.following;
}

export function userIsFollowingContextObject(
  user: UserLike,
  context: string,
  id: string,
) {
  const existingFollowingContext = getUserFollowing(user, context);
  const followingContent = existingFollowingContext.find((f) => f._id === id);
  return {
    ...(followingContent || { type: context, _id: id, following: false }),
  };
}
